(() => {
  const storageKey = 'apollonCollectionColumns';
  const validColumns = ['4', '5'];
  let observer;
  let scheduled = false;

  const getSavedColumns = () => {
    try {
      const saved = window.localStorage.getItem(storageKey);
      return validColumns.includes(saved) ? saved : '4';
    } catch (error) {
      return '4';
    }
  };

  const saveColumns = (columns) => {
    try {
      window.localStorage.setItem(storageKey, columns);
    } catch (error) {
      // The control still works when storage is unavailable.
    }
  };

  const labels = () => {
    const isFrench = document.documentElement.lang.toLowerCase().startsWith('fr');
    return isFrench
      ? { group: 'Produits par rangée', show: 'Afficher :', four: '4 par rangée', five: '5 par rangée' }
      : { group: 'Products per row', show: 'Show:', four: '4 per row', five: '5 per row' };
  };

  const applyColumns = (columns) => {
    const grid = document.querySelector('#ProductGridContainer #product-grid');
    if (!grid) return;

    grid.classList.remove('apollon-grid--4', 'apollon-grid--5', 'apollon-grid--6');
    grid.classList.add(`apollon-grid--${columns}`);

    document.querySelectorAll('.apollon-grid-density__option').forEach((button) => {
      const active = button.dataset.gridColumns === columns;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const createControl = () => {
    const productColumn = document.querySelector('.apollon-product-column');
    const gridContainer = productColumn?.querySelector('#ProductGridContainer');
    if (!productColumn || !gridContainer) return null;

    let control = productColumn.querySelector('.apollon-grid-density');
    if (control) return control;

    const text = labels();
    control = document.createElement('div');
    control.className = 'apollon-grid-density';
    control.setAttribute('role', 'group');
    control.setAttribute('aria-label', text.group);
    control.innerHTML = `
      <span class="apollon-grid-density__label">${text.show}</span>
      <button class="apollon-grid-density__option" type="button" data-grid-columns="4" aria-pressed="false">${text.four}</button>
      <span class="apollon-grid-density__separator" aria-hidden="true">|</span>
      <button class="apollon-grid-density__option" type="button" data-grid-columns="5" aria-pressed="false">${text.five}</button>
    `;

    control.addEventListener('click', (event) => {
      const button = event.target.closest('[data-grid-columns]');
      if (!button) return;

      const columns = button.dataset.gridColumns;
      if (!validColumns.includes(columns)) return;

      saveColumns(columns);
      applyColumns(columns);
    });

    productColumn.insertBefore(control, gridContainer);
    return control;
  };

  const install = () => {
    scheduled = false;
    createControl();
    applyColumns(getSavedColumns());
  };

  const scheduleInstall = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(install);
  };

  const startObserver = () => {
    if (observer) observer.disconnect();
    const collectionArea = document.querySelector('.apollon-product-column');
    if (!collectionArea) return;

    observer = new MutationObserver(scheduleInstall);
    observer.observe(collectionArea, { childList: true, subtree: true });
  };

  const init = () => {
    install();
    startObserver();

    document.addEventListener('shopify:section:load', () => {
      scheduleInstall();
      window.requestAnimationFrame(startObserver);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
